<template>
  <div v-if="$store.state.websiteDataLoaded">
    <section class="main" v-animate.fade="'slide-left'">
      <div class="cg">
        <h1>
          {{ getPageBySlug('citizenship').title }}
        </h1>
      </div>
    </section>
    <section class="info" v-animate.fade="'slide-up'">
      <div class="inner cg" v-html="getPageBySlug('citizenship').body"></div>
    </section>
    <section class="list">
      <div class="cg">
        <h1>Jurisdictions</h1>
        <countries/>
      </div>
    </section>
    <contact/>
  </div>
</template>

<script>
import Countries from '@/components/countries';
import Contact from '@/components/contact-bar';
import { mapGetters } from 'vuex'

export default {
  components: { Countries, Contact },
  computed: {
      ...mapGetters(['getPageBySlug']),
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/mixins.scss';

.main {
  padding: 40px 0;
}

h1 {
  font-weight: 400;
}

.info {
  position: relative;
  padding: 40px 0;
  background: #f9f9f9;
  z-index: 1;
  
  &:before {
    content: '';
    background: url('../../assets/citizenship/bg.png') no-repeat;
    width: 1209px;
    max-width: 100vw;
    height: 605px;
    top: -180px;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
  }

  p {
    @include desktop {
      padding-right: 550px;
    }
  }

  .inner {
    position: relative;

    &:after {
      width: 550px;
      height: 501px;
      background: url('../../assets/citizenship/1.png') no-repeat;
      position: absolute;
      right: 0;
      top: -100px;

      @include desktop {
        content: '';
      }
    }
  }
}

.list {
  background: #eff8fe;

  @include mobile {
    padding: 40px 0;
  }

  @include desktop {
    padding: 80px 0;
  }

  h1 {
    font-weight: normal;
  }
}
</style>